import { IDeviceRepository } from "../../adapters/driven/repositories/deviceRepository";

export const DeviceServiceImplFactory = ({
  deviceRepository,
}: {
  deviceRepository: IDeviceRepository;
}) => {
  const getDeviceConnectionStatus: IGetDeviceConnectionStatus = async ({
    deviceId,
  }) => {
    try {
      const data = await deviceRepository.getDeviceConnectionStatusAPI({
        device_id: deviceId,
      });
      return { success: true, data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getDeviceConnectionStatus,
  };
};
